import { cn } from '@cocoonspace/ui/lib/utils'

export const DividerLabel = ({
	children,
	centered = false,
	classNames,
}: {
	children: React.ReactNode
	centered?: boolean
	classNames?: {
		container?: string
		label?: string
		divider?: string
	}
}) => (
	<div className={cn('flex w-full items-center gap-2', classNames?.container)}>
		{centered && (
			<hr className={cn('border-primary flex-1', classNames?.divider)} />
		)}

		<span className={cn('text-xs font-bold uppercase', classNames?.label)}>
			{children}
		</span>

		<hr className={cn('border-primary flex-1', classNames?.divider)} />
	</div>
)
